
import React,{ useState, useEffect, useRef }  from 'react';
import {useUser} from '@wollo-lib/kpe-context'
import {Segment,Header, Button,} from 'semantic-ui-react'
import {v1 as uuid} from 'uuid'
import {useHistory} from 'react-router-dom'
import EditUser from '../EditUser/EditUser'




const AddKunde=({dienst,setKunden,db})=>{

     const [user,setUser]=useState(
        {
            UID:uuid(),
            Vorname:'',
            Nachname:'',
            Strasse:'',
            Strasse2:'',
            PLZ:'',
            Ort:'',
            Land:'CH',
            mobil:'',
            Festnetz:'',
            email:'',
            attr:'{}',
            certified:'personal',
            ShopId: '',
            Modus: 'manuell'


        }
    )

    const history=useHistory()





   


    const afterSubmit=()=>
    {
        setKunden([user])
        history.push(`/register/paket/${dienst}/select`)
    }


   

    return (
        <>
            <Segment>
                <Header as="h3" content="fehlenden Kunden nacherfassen"/>
                <EditUser
                    user={user}
                    setUser={setUser}
                    afterSubmit={afterSubmit}
                    db= {db}

                />
                

                <Button
                    negative
                    icon='close'
                    labelPosition='right'
                    content='Abbrechen'
                    onClick={e=>history.push(`/register/paket/${dienst}/correct`)}
                />
            </Segment>

        </>   
    )
    
}
export default AddKunde
